import React, { useContext } from 'react'
import { Modal, Form, Button, DatePicker } from 'antd'
import moment from 'moment'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserSave } from 'utils/User'

const UpdateAnalysisExpiryDateModal = ({
  openModal,
  onCancel,
  btnLoading,
  updateData,
  onFinish,
}) => {
  const { state: { currentUser, userPermissions, isClient } = {} } = useContext(AppContext) || {}
  const canSubmit =
    canUserEdit(userPermissions || currentUser, isClient) &&
    canUserSave(userPermissions || currentUser, isClient)

  const [form] = Form.useForm()
  return (
    <div>
      <Modal
        title='Update Analysis Expiry Date'
        visible={openModal}
        footer={null}
        onCancel={onCancel}
      >
        <Form
          form={form}
          layout='vertical'
          name='form_in_modal'
          initialValues={{
            expiryDate: updateData ? moment(updateData?.expiryDate) : undefined,
          }}
          onFinish={(values) => {
            if (!canSubmit) return
            onFinish(values)
          }}
        >
          <Form.Item
            name='expiryDate'
            label='Analysis Expiry Date'
            rules={[
              {
                required: true,
                message: 'Please select Analysis Expiry Date!',
              },
            ]}
          >
            <DatePicker getPopupContainer={trigger => trigger.parentElement} format={'YYYY-MM-DD'} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              loading={btnLoading}
              disabled={!canSubmit}
            >
              Submit Analysis Expiry Date
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default UpdateAnalysisExpiryDateModal
